import { defineStore } from 'pinia';

export const useEventStore = defineStore('event', {

  state: () => ({
    isCommentFocused: false,
    defaultPagination:25,
    pullDownSearch: false,
    openBottomSheet: false,
    flowBottomSheet: false,
    outOfOfficeState: "main",
    searchText: '',
    flowToast:{
      show: false,
      message: "",
      type: "success",
      icon: "check",
      iconColor: "green",
    },
    flowOptions: {
      approved: false,
      decline: false,
      inProgress: false,
      processed: false,
      upcoming: false,
    },
    documentAction: "approved",
    documentValidationError: false,
    resetPasswordKeyboardOpen: false,
  }),
  actions: {
    updatePullDownSearch(value: boolean) {
      this.pullDownSearch = value;
    },
    updateFlowToast(value: boolean, message: string, type: string, icon: string = "check", iconColor: string = "green") {
      this.flowToast.show = value;
      this.flowToast.message = message;
      this.flowToast.icon = icon;
      this.flowToast.iconColor = iconColor;
      this.flowToast.type = type;
    },
    updateOutOfOfficeState(value: string) {
      this.outOfOfficeState = value;
    },
    updateSearchText(value: string) {
      this.searchText = value;
    },
    updateFocused(value: boolean) {
      this.isCommentFocused = value;
    },
    updateResetPasswordKeyboardOpen(value: boolean) {
      this.resetPasswordKeyboardOpen = value;
    },
    updateFlowBottomSheet(value: boolean, option: keyof typeof this.flowOptions) {
      this.flowBottomSheet = value;
      Object.keys(this.flowOptions).forEach(key => {
        this.flowOptions[key] = key === option;
      });
    },
    updateBottomSheet(value: boolean) {
      this.openBottomSheet = value;
      if(!value){
        this.documentAction = "approved";
        this.documentValidationError = false;
        this.flowBottomSheet = value;
      }
    },
    updateDocumentAction(value: string) {
      this.documentAction = value;
      this.documentValidationError = false;
    },
    updateDocumentValidateError(value: boolean) {
      this.documentValidationError = value;
    }
  }
});